import { useQuery } from "@apollo/client";
import { Label, Select, Spinner, toaster } from "evergreen-ui";
import React, { useEffect } from "react";
import { GET_PACKAGES } from "src/Queries/business.shared";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  position: relative;
`;

const LoadingContainer = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
interface IProps {
  label?: string;
  onSelect?: any;
  base?: boolean | null;
}
const PackageSelector: React.SFC<IProps> = ({
  label,
  onSelect,
  base = null,
}) => {
  const { data, loading, error } = useQuery(GET_PACKAGES, {
    variables: {
      where:
        base === null
          ? {}
          : {
              base: {
                _eq: base,
              },
            },
    },
  });

  useEffect(() => {
    if (!loading && error) {
      toaster.danger(error.message);
    }
  }, [error, loading]);
  return (
    <Container>
      <Label>{label}</Label>
      <Select
        onChange={(e) => {
          onSelect(data.packages[e.target.value]);
        }}
      >
        {loading && (
          <LoadingContainer>
            <Spinner />
          </LoadingContainer>
        )}
        <option>Select a package</option>
        {!loading &&
          data &&
          data.packages &&
          data.packages.map((pac, index) => (
            <option key={index} value={index}>
              ({pac.package_country.name}) {pac.chinese_name} | {pac.name}:{" "}
              {pac.min} + {pac.system_offer} @{" "}
              {pac.package_country.currency + pac.unit_price}
            </option>
          ))}
      </Select>
    </Container>
  );
};

export default PackageSelector;
